var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts"},[_c('transition-group',{attrs:{"name":"scroll-x-transition"}},_vm._l((_vm.alerts),function(alert){return _c('alert',{key:`alert-${alert.id}`,attrs:{"id":alert.id,"text":alert.text,"type":alert.type,"multi":alert.multi,"html":alert.html,"timeout":alert.timeout}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }